// extracted by mini-css-extract-plugin
module.exports = {"flag":"index_flag_3wOwh"};